<template>
  <span class="nbre">{{ 'products.count' | transchoice(count, { '%count%': count }) }}</span>
</template>

<script>
import {mapState} from 'vuex';
import store from '../store';

export default {
  name: 'ponroy-product-count',
  store,
  computed: {
    ...mapState('facetedFilter', [
      'count',
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/ProductCount.vue